/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $(document).ready(function(){

          $('button.hamburger').on('click', function(){
            $(this).toggleClass('is-active');
            $('.menu-mobile').toggleClass('is-active');
          });

        });

        if($('#back-to-top').length){
          var scroll_trigger = 100;
          var backtotop = function(){
            var scroll_top = $(window).scrollTop();

            if(scroll_top > scroll_trigger){
              $('#back-to-top').addClass('show');
            } else{
              $('#back-to-top').removeClass('show');
            }

          };

          backtotop();

          $(window).on('scroll', function(){
            backtotop();
          });

          $('#back-to-top').on('click', function(e){
            e.preventDefault();

            $('html, body').animate({
              scrollTop: 0
            }, 700);
          });
        }

      },
      finalize: function() {
      }
    },

    // CONNECT
    'connect': {
      init: function() {


        function fetch_json(path, callback) {
          var httpRequest = new XMLHttpRequest();
          httpRequest.onreadystatechange = function() {
              if (httpRequest.readyState === 4) {
                  if (httpRequest.status === 200) {
                      var data = JSON.parse(httpRequest.responseText);
                      if (callback) callback(data);
                  }
              }
          };

          httpRequest.open('GET', path);
          httpRequest.send();
        }

        var lastfm_api = 'http://ws.audioscrobbler.com/2.0/?method=user.getRecentTracks&user=katsygarcia&limit=1&api_key=210ded49cd784a047cef1ac8f4a56dd9&format=json';

        $(document).ready(function(){

          // NOW PLAYING
          fetch_json(lastfm_api, function(data){
          	var artist = data.recenttracks.track[0].artist['#text'];
          	var song = data.recenttracks.track[0].name;
          	var song_url = data.recenttracks.track[0].url;
          	var img_link = data.recenttracks.track[0].image[3]['#text'];

          	var play_text = '<span style="font-weight: 900;">' + song + '</span><br /><span style="font-style: italic;">' + artist + '</span>';

          	$('#now-playing').html(play_text);
          });


        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    }

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
